'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CatDropdown } from '@blocks-react/components/Dropdown';
import { CatList } from '@blocks-react/components/List';
import { CatListItem } from '@blocks-react/components/ListItem';
import { useFormContext } from 'react-hook-form';
import { useDropdownController } from '../../../hooks/form-controllers/useDropdownController';
import { useCallback } from 'react';
import styles from '../DealerLocator.module.scss';
import cx from 'classnames';
const SORT_ID = 'sortOrder';
export const DealerLocatorFiltersSortDropdown = ({ title, sortingOptions }) => {
    const { watch, setValue } = useFormContext();
    const { dropdownField } = useDropdownController({ name: SORT_ID });
    const value = watch(SORT_ID)?.value || sortingOptions[0]?.value;
    const handleSelect = useCallback((e) => {
        const newValue = sortingOptions.find((option) => option.value === e.detail.value);
        setValue(SORT_ID, newValue, { shouldDirty: true });
    }, [sortingOptions, setValue]);
    return (_jsxs("div", { className: "my-4", children: [_jsx("p", { className: cx(styles['dealer-locator-text'], 'cat-u-theme-typography-label-lg mb-0'), children: title }), _jsx(CatDropdown, { ...dropdownField, hideLabel: true, "data-testid": "dealer-locator-filters-sort-dropdown", value: value, size: "md", onBlSelect: handleSelect, children: _jsx(CatList, { children: sortingOptions.map((item) => {
                        const isOptionSelected = watch(SORT_ID)?.value === item.value;
                        return (_jsx(CatListItem, { value: item.value, isActive: isOptionSelected, children: item.label }, item.value));
                    }) }) })] }));
};
